export default "__VITE_ASSET__Dyi1Uyk3__"